import { useGetLoginCodeApi } from 'api/private/loginPage/useGetLoginCodeApi';
import { useLoginApi } from 'api/private/loginPage/useLoginApi';
import { useLoginByPassword } from 'api/private/loginPage/useLoginByPassword';
import { LoginPageTemplate } from 'components/private/LoginPage/LoginPageTemplate/LoginPageTemplate';
import { useEffect, useState } from 'react';

const LoginPage = () => {
  const [loginByPasswordLoading, loginByPassword] = useLoginByPassword();
  const [getCodeLoading, getCode] = useGetLoginCodeApi();
  const [loginLoading, login] = useLoginApi();

  const [loginMethod, setLoginMethod] = useState('password');
  const [currentStep, setCurrentStep] = useState(1);
  const [phoneNumber, setphoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [otpCode, setOtpCode] = useState('');

  const onLoginByPassword = () => {
    loginByPassword(phoneNumber, password);
  };

  const onLoginStepOne = () => {
    getCode(phoneNumber, () => setCurrentStep(currentStep + 1));
  };

  const onLoginStepTwo = () => {
    login(phoneNumber, otpCode);
  };

  const onGoBack = () => {
    setCurrentStep(1);
    setOtpCode('');
  };

  useEffect(() => {
    if (otpCode.length === 4) {
      onLoginStepTwo();
    }
  }, [otpCode]);

  return (
    <LoginPageTemplate
      currentStep={currentStep}
      phoneNumber={phoneNumber}
      otpCode={otpCode}
      password={password}
      getCodeLoading={getCodeLoading}
      loginLoading={loginLoading || loginByPasswordLoading}
      loginMethod={loginMethod}
      onPhoneInputChange={value => setphoneNumber(value)}
      onOtpInputChange={value => setOtpCode(value)}
      onPasswordChange={value => setPassword(value)}
      onLoginStepOne={onLoginStepOne}
      onLoginStepTwo={onLoginStepTwo}
      onLoginByPassword={onLoginByPassword}
      onGoBack={onGoBack}
      setLoginMethod={setLoginMethod}
    />
  );
};

export default LoginPage;
